import {
  setIsWriterDeviationFeatured,
  saveWriterDeviation,
  saveWriterDeviationSuccess,
  saveWriterDeviationFailure,
  resetWriterPopup,
  publishWriterDeviation,
} from '../actions';

export const defaultState = {
  isSubmitting: false,
  deviationId: null,
  error: null,
  isFeatured: false,
};

export default {
  [setIsWriterDeviationFeatured.toString()]: (state, action) => ({
    ...state,
    isFeatured: action.payload.isFeatured,
  }),
  [saveWriterDeviation.toString()]: state => ({
    ...state,
    isSubmitting: true,
    error: null,
  }),
  [publishWriterDeviation.toString()]: state => ({
    ...state,
    isSubmitting: true,
    error: null,
  }),
  [saveWriterDeviationSuccess.toString()]: (state, action) => ({
    ...state,
    isSubmitting: false,
    deviationId: action.payload.deviationId,
    error: null,
  }),
  [saveWriterDeviationFailure.toString()]: (state, action) => ({
    ...state,
    isSubmitting: false,
    error: action.payload.error,
  }),
  [resetWriterPopup.toString()]: () => defaultState,
};
